import React, { useState, useEffect } from "react";
import CustomerProgress from "../../../components/progressBar/CustomerProgress";

const NextofKin = ({
  id_R,
  closeNextOfKin,
  nextofKin,
  relationship,
  setRelationship,
  dateOfBirth,
  setDateOfBirth,
  fullName,
  setFullName,
  location,
  setLocation,
  openReviewModal,
  openAddInfoModal,
  mobileNumber,
  setMobileNumber,
}) => {
  const [phoneError, setPhoneError] = useState("");

  const validatePhoneNumber = (number) => {
    if (!number) {
      setPhoneError("");
      return false;
    }

    if (number.startsWith("0") && number.length !== 10) {
      setPhoneError("Phone number starting with 0 must be 10 digits");
      return false;
    }

    if (number.startsWith("254") && number.length !== 12) {
      setPhoneError("Phone number starting with 254 must be 12 digits");
      return false;
    }

    if (!number.startsWith("0") && !number.startsWith("254")) {
      setPhoneError("Phone number must start with 0 or 254");
      return false;
    }

    setPhoneError("");
    return true;
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // allow digits only

    // Restrict length depending on prefix
    if (value.startsWith("254")) {
      value = value.slice(0, 12);
    } else if (value.startsWith("0")) {
      value = value.slice(0, 10);
    }

    setMobileNumber(value);

    // Validate only if user typed something
    if (value.length > 0) {
      validatePhoneNumber(value);
    } else {
      setPhoneError("");
    }
  };

  const handleBackButtonClick = () => {
    // Close the current modal
    closeNextOfKin();

    // Open the next modal
    openAddInfoModal();
  };
  const handleNextButtonClick = () => {
    // Close the current modal
    closeNextOfKin();

    // Open the next modal
    openReviewModal();
  };

  const [isInputsFilled, setIsInputsFilled] = useState(false);
  const today = new Date()?.toISOString()?.split("T")[0];

  useEffect(() => {
    const phoneValid = validatePhoneNumber(mobileNumber);

    const areInputsFilled =
      fullName &&
      dateOfBirth &&
      relationship &&
      location &&
      mobileNumber &&
      phoneValid;

    setIsInputsFilled(areInputsFilled);
  }, [dateOfBirth, relationship, fullName, location, mobileNumber]);
  return (
    <>
      <div
        id={id_R}
        className={`${
          nextofKin ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex fixed min-h-[80%] w-[70%]">
          <div className="relative flex bg-white shadow w-full mx-auto">
            <div className=" w-[28%]">
              <div className="pt-4 px-2 rounded-t">
                <p className="text-[20px] font-bold text-[#000] ml-5">
                  Add Member
                </p>
              </div>
              <div className="mt-[32px] px-6">
                <CustomerProgress step={6} />
              </div>
            </div>
            <div className="w-[72%] flex flex-col justify-between">
              <div className="flex items-center justify-end">
                <button
                  onClick={closeNextOfKin}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
                  data-modal-toggle={id_R}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div>
                <div className="mt-5 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Add next of kin
                  </p>
                  <div className="text-[#000] mt-5 text-[15px] font-normal">
                    <p className="w-[100%]">
                      Enter Member’s next of kin details details. This is to
                      ensure the safety and security of the member’s membership
                      in the SACCO.
                    </p>
                  </div>
                </div>

                <div className="flex w-full justify-between mt-12 mr-4">
                  <div className="flex w-[50%] flex-col justify-center">
                    <label
                      htmlFor="fullNameInput"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Full name
                    </label>
                    <input
                      type="text"
                      id="fullNameInput"
                      name="fullName"
                      placeholder="Enter the full name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                  <div className="flex w-[50%] flex-col justify-center">
                    <label
                      htmlFor="dateOfBirthInput"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Date of birth
                    </label>
                    <input
                      type="date"
                      id="dateOfBirthInput"
                      name="jobTitle"
                      placeholder="Enter the date of Birth"
                      value={dateOfBirth}
                      max={today}
                      onChange={(e) => setDateOfBirth(e.target.value)}
                      className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                </div>

                <div className="flex w-full justify-between mt-12 mr-4">
                  <div className="flex w-[50%] flex-col justify-center">
                    <label
                      htmlFor="relationship"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Relationship
                    </label>
                    <input
                      type="text"
                      id="relationship"
                      name="relationship"
                      placeholder="Enter the relationship"
                      value={relationship}
                      onChange={(e) => setRelationship(e.target.value)}
                      className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                  <div className="flex w-[50%] flex-col justify-center">
                    <label
                      htmlFor="dateOfBirthInput"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Phone number
                    </label>
                    <input
                      type="text"
                      id="mobileNumberInput"
                      name="mobileno"
                      placeholder="Enter the phone number"
                      value={mobileNumber}
                      onChange={handlePhoneChange}
                      className={`w-[100%] h-10 px-4 rounded-[4px] border ${
                        phoneError ? "border-red-500" : "border-[#000]"
                      }`}
                    />

                    {phoneError && (
                      <p className="text-red-500 text-sm mt-1">{phoneError}</p>
                    )}
                  </div>
                </div>

                <div className="flex w-full justify-between mt-12 mr-4">
                  <div className="flex w-[50%] flex-col justify-center">
                    <label
                      htmlFor="location"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Location
                    </label>
                    <input
                      type="text"
                      id="location"
                      name="location"
                      placeholder="Enter the location"
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                      className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-16 mb-8 mr-5">
                <div className="flex items-center justify-between w-[15vw]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id_R}
                    type="button"
                    className="text-[#000] bg-[#8ED6A8] hover:bg-[#8ED6A8] focus:outline-none font-normal rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                </div>
                <button
                  onClick={handleNextButtonClick}
                  type="button"
                  className={`text-white ${
                    isInputsFilled
                      ? "bg-[#005C53] hover:bg-[#005C53] focus:outline-none"
                      : "bg-[#D9D9D9] pointer-events-none"
                  } block font-normal rounded-[5px] text-sm px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NextofKin;
